export function getSampleProposals() {
  return [
    { id: "P-001", opportunity: "Sample RFP 1", status: "Draft" },
    { id: "P-002", opportunity: "Sample RFP 2", status: "Submitted" },
    { id: "P-003", opportunity: "Sample RFP 3", status: "Awarded" },
  ];
}
